(function() {
    'use strict';

    angular
        .module('gatewayApp')
        .controller('DailyController', DailyController);

    DailyController.$inject = ['Setting', '$scope', 'SelectedPepper', '$state', 'MessageService'];

    function DailyController (Setting, $scope, SelectedPepper, $state, MessageService) {
        var vm = this;

        vm.datas = {pepperId: null, pepperSettingList: []};
        vm.repeats = [{code: 1, value: "毎年"}, {code: 2, value: "毎月"}, {code: 3, value: "毎週"}];
        vm.index = null;
        vm.pepper = SelectedPepper.current();

        vm.loadPepperSettings = loadPepperSettings;
        vm.add = add;
        vm.del = del;
        vm.save = save;
        vm.cancel = cancel;
        vm.changeDays = changeDays;
        vm.copy = copy;
        vm.loadSystemPepperSettings = loadSystemPepperSettings;

        vm.loadPepperSettings();
        vm.loadSystemPepperSettings();

        $scope.$on('pepperChanged', function() {
            vm.pepper = SelectedPepper.current();
            loadPepperSettings();
        });

        function loadPepperSettings() {
            Setting.query({pepperId: vm.pepper.id, type: 2}, function(result) {
                vm.datas.pepperSettingList = result;
            });
        }

        function add() {
            var pepperSetting = {id: null, pepperId: null, variableType: 4, itemName: null, variableName: null, variableValue: null, repeatType: 1, sampleText: null,
                pepperSettingMonthly: {id: null, day1: null, day2: null, day3: null, day4: null, day5: null, day6: null, day7: null,
                    day8: null, day9: null, day10: null, day11: null, day12: null, day13: null, day14: null,
                    day15: null, day16: null, day17: null, day18: null, day19: null, day20: null, day21: null,
                    day22: null, day23: null, day24: null, day25: null, day26: null, day27: null, day28: null,
                    day29: null, day30: null, day31: null},
                pepperSettingWeekly: {id: null, day1: null, day2: null, day3: null, day4: null, day5: null, day6: null, day7: null},
                selected: false};
            vm.datas.pepperSettingList.push(pepperSetting);
            changeDays(vm.datas.pepperSettingList.length - 1);
        }

        function del(index) {
            vm.datas.pepperSettingList.splice(index, 1);
        }

        function save() {
            vm.isSaving = true;
            vm.datas.pepperId = vm.pepper.id;
            vm.datas.type = 2;
            Setting.save(vm.datas, onSaveSuccess, onSaveError);
        }

        function cancel() {
            vm.loadPepperSettings();
        }

        function onSaveSuccess() {
            vm.isSaving = false;
            vm.loadPepperSettings();
            //AlertService.success("daily.home.success");
            MessageService.success("daily.home.success", "message_success");
            $state.go('script');
        }

        function onSaveError() {
            vm.isSaving = false;
            //AlertService.error("daily.home.error");
            MessageService.error("daily.home.error", "message_error");
        }

        function changeDays(index) {
            vm.index = index;
        }

        function copy(index) {
            if (confirm("既にデフォルト項目が上書きしますか。")) {
                for (var i = vm.datas.pepperSettingList.length - 1; i >= 0; i --) {
                    if (vm.datas.pepperSettingList[i].variableType == 3) {
                        vm.datas.pepperSettingList.splice(i, 1);
                    }
                }
                for (var i = 0; i < vm.systemSetting[index].pepperSettingList.length; i ++) {
                    var setting = angular.copy(vm.systemSetting[index].pepperSettingList[i]);
                    setting.id = null;
                    setting.variableType = 3;
                    setting.pepperSettingMonthly != null ? setting.pepperSettingMonthly.id = null : null;
                    setting.pepperSettingWeekly != null ? setting.pepperSettingWeekly.id = null : null;
                    vm.datas.pepperSettingList.push(setting);
                }
            }
        }

        function loadSystemPepperSettings() {
            Setting.system({type: 6}, function(result) {
                vm.systemSetting = result;
            });
        }
    }
})();
